import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            "Next": "Next",
            "Submit": "Submit",
            "Go Back": "Go back",
            "Select an option": "Please select an option",
        }
    },
    fr: {
        translation: {
            "Next": "Next",
            "Submit": "Submit",
            "Go Back": "Go back",
            "Select an option": "Veuillez sélectionner une option",
        }
    },
    de: {
        translation: {
            "Next": "Weiter",
            "Submit": "Submit",
            "Go Back": "Go back",
            "Select an option": "Bitte wählen Sie eine Option",
        }
    },
    it: {
        translation: {
            "Next": "Next",
            "Submit": "Submit",
            "Go Back": "Go back",
            "Select an option": "Selezionate un'opzione",
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "de", 
        interpolation: {
            escapeValue: false 
        }
    });

export default i18n;